module.exports = __webpack_public_path__ + "img/resources_map.749ab1d4.png";